import RefashionLogo, { RefashionStatus } from '@/components/RefashionLogo';
import Paragraph from '@/design_system/Typography/Paragraph';
import { ParagraphProps } from '@/design_system/Typography/Paragraph/Paragraph';
import { I18nWording, useDatabaseTranslation } from '@/services/i18n';

const ActionName = ({
  actionType,
  refashionStatus,
  duplicateActionNumber,
  weight = 'regular',
  disabled = false,
}: {
  actionType: { name: I18nWording };
  refashionStatus?: RefashionStatus | null;
  duplicateActionNumber?: number;
  weight?: ParagraphProps['weight'];
  disabled?: boolean;
}) => {
  const { _db } = useDatabaseTranslation();

  return (
    <Paragraph weight={weight} color={disabled ? 'disabled' : undefined}>
      {_db(actionType.name)}
      {!!duplicateActionNumber && ` #${duplicateActionNumber}`}
      {!!refashionStatus && (
        <>
          {' '}
          <RefashionLogo status={refashionStatus} />
        </>
      )}
    </Paragraph>
  );
};

export default ActionName;
